export default __webpack_public_path__ + "static/media/solidrums.2f8fed82.png";